<!------------------------------------------------------------------------------
  Copyright (c) 2019. Keni Williams <kenneth.williams@estuk.co.uk>

  This file eventTileCards.vue is part of event_pass_client.dev.
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential
  eventTileCards.vue can not be copied and/or distributed
  without the express permission of Keni Williams <kenneth.williams@estuk.co.uk>
  ----------------------------------------------------------------------------->

<!------------------------------------------------------------------------------
 File: eventTileCards
 Created by Keni Williams <kenneth.williams@estuk.co.uk>.
 with: IntelliJ IDEA
 Date: 2019-02-25
 Time: 17:25
------------------------------------------------------------------------------->
<template>
    <div>
        <div v-if="records.length > 1" class="row">
            <div class="col-12">
                <h3 class="card-title">
                    <bold-words :word="{
                        text:category
                        }"
                    />
                </h3>
            </div>
        </div>
        <div class="row">
            <template v-if="first_half.length > 2">
                <div class="col-12 col-md-6">
                    <div data-ref="first_half" class="row">
                        <template v-for="record in first_half">
                            <div class="col-12 col-md-6">
                                <tile-card
                                        :record="record"
                                        :records="first_half"
                                />
                            </div>
                        </template>
                    </div>
                    <div data-ref="second_half" class="row">
                        <template v-for="record in second_half">
                            <div class="col-12 col-md-6">
                                <tile-card
                                        :record="record"
                                        :records="second_half"
                                />
                            </div>
                        </template>
                    </div>
                </div>
                <!--                the remaining events on calendar-->
                <div class="col-12 col-md-6">
                    <nav class="calendar calendar-list">
                        <ul data-element-type="event-list" class="list-group">

                            <template v-for="record in remaining_records">
                                <li data-month-counter="0"
                                    class="list-group-item border-0 px-0 pb-0 pb-md-2 pt-0 pt-md-2">
                                    <a :href="record.url"
                                       class="d-flex py-1 hover-show-watch pl-0 pl-md-2"
                                       data-ticket-counter="0">
                                        <date-block class="pr-3"
                                                    :date="record.start_date"></date-block>
                                        <div data-element="details section"
                                             class="w-100 border border-left-0 border-right-0 border-top-0 pb-2">
                                            <div class="h6 p-0">{{readTitle(record)}}</div>
                                            <div>{{readDescription(record)}}</div>
                                        </div>
                                    </a>
                                </li>
                            </template>

                        </ul>
                    </nav>
                </div>
            </template>
            <!-- center row if less than or equal to 2-->
            <template v-else-if="first_half.length <= 2">
                <div data-ref="first_half<=2" class="col-12 col-md-8 offset-md-2">
                    <div class="row">
                        <template v-for="record in first_half">
                            <div class="col-12 col-md-6">
                                <tileCard
                                        :record="record"
                                        :records="first_half"
                                />
                            </div>
                        </template>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import {_} from 'underscore';
    import {
        getDate,
        getTime,
        setDate,
        getYear,
        getMonth,
        getDay
    } from '../../../../../../app/Shared/Resources/Assets/js/helpers/format.date';

    Vue.component('tileCard', require('./tileCard'));
    export default {
        name: "event-tile-cards",
        components: {},
        props: {
            category_title: {
                type: String,
                default: null
            },
            records: {
                type: Array,
                default: function () {
                    return Array
                }
            },
            remaining_records: {
                type: Array,
                default: function () {
                    return Array
                }
            },
        },
        created() {
        },
        destroyed() {
        },
        mounted() {
            if (typeof this.category_title !== 'undefined' && this.category_title !== null) {
                this.category = this.category_title + ' events'
            } else {
                this.category = 'upcoming events'
            }

            if (this.records.length <= 2) {
                this.first_half = this.records;
            } else {
                this.first_half = _.first(this.records, 2);
                this.second_half = _.first(_.rest(this.records, 2),2);
            }
        },
        data() {
            return {
                category: '',
                first_half: [],
                second_half: []
            }
        },
        methods: {
            log(...args) {
                console.log(...args);
            },
            readTitle(item) {
                return item.event_data.lang.en_GB.title;
            },
            readDescription(item) {
                return item.event_data.lang.en_GB.description.short;
            },
            getTheYear(date) {
                if (date == null) {
                    return 'TBC';
                }
                return getYear(date, true)
            },
            getTheMonth(date) {
                if (date == null) {
                    return '';
                }
                return getMonth(date, 'name_short')
            },
            getDay(date) {
                if (date == null) {
                    return '';
                }
                return getDay(date)
            },
        },
        watch: {},
        computed: {}
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/front/modules/eventTileCards.vue